import React, { useEffect, useState } from "react";
import { Col, Row, Form } from "react-bootstrap";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddIcon from "@mui/icons-material/Add";
import {
  IconButton,
  InputAdornment,
  TextField,
  Collapse,
  Grid,
} from "@mui/material";
import Button from "@mui/material/Button";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ScheduleFileInfoReport from "./ScheduleFileInfoReport";
import {
  createQuery,
  generateReport,
  getFields,
  getsavedQueryDetails,
  getSaveQuery,
  updateQueryReport,
  userActivity,
} from "../../api/fileInfoReportApi/fileInfoReportApi";
import NavigationBar from "../NavigationBar/NavigationBarComponent";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import { useLoader } from "../../context/LoaderContext";
import { useSnackbar } from "../Common/SnackbarContext";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import LocalStorageUtil from "../../utils/localStorage";
import { appSettings } from "../../config/appSetting";

function not(a: readonly number[], b: readonly number[]) {
  return a.filter((value) => !b.includes(value));
}

function intersectionLeft(a: readonly number[], b: any) {
  return b.filter((column: any) => a.includes(column?.metaDataFieldId));
}

function intersectionRight(a: readonly number[], b: any) {
  return b.filter((column: any) =>
    a.includes(column?.metaDataFieldId || column?.fileInfoReportID)
  );
}

interface Option {
  value: number;
  label: string;
}

interface Category {
  label: string;
  options: Option[];
}

interface FileInfoReportProps {
  businessUnitData: any;
}

const FileInfoReport: React.FC<FileInfoReportProps> = ({
  businessUnitData,
}) => {
  const [criteria, setCriteria] = useState([
    { id: Date.now(), condition: "", field: "", operator: "", value: "" },
  ]);
  const [searchTermLeft, setSearchTermLeft] = useState("");
  const [searchTermRight, setSearchTermRight] = useState("");
  const [data, setData] = useState<any>([]);
  const [checked, setChecked] = React.useState<readonly number[]>([]);
  const [left, setLeft] = useState<readonly number[]>([]);
  const [right, setRight] = useState<any>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isClearData, setIsClearData] = useState(true);
  const [fieldsData, setFieldsData] = useState<Category[]>([]);
  const [savedQueryDetails, setSavedQueryDetails] = useState<any>([]);
  const [formErrors, setFormErrors] = useState({
    generateReport: "",
    reportFormat: "",
    toEmail: "",
    bccEmail: "",
    ccEmail: "",
  });

  const [errors, setErrors] = useState<{
    sourceNameError?: string;
    selectedFieldsError?: string;
  }>({});

  const [history, setHistory] = useState<
    Array<{
      left: readonly number[];
      right: readonly number[];
      checked: readonly number[];
    }>
  >([]);
  
  const { setLoading } = useLoader();
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [queryResponse, setQueryResponse] = useState();
  const [saveQueryData, setSaveQueryData] = useState<any>([]);
  const [savedLeftData, setSavedLeftData] = useState<any>();
  const [savedRightData, setSavedRightData] = useState<any>();
  const [savedCriteriaData, setSavedCriteriaData] = useState<any>();
  const [reportFormat, setReportFormat] = useState<any>();
  const [scheduleGenerateReportData, setScheduleGenerateReportData] =
    useState<any>();
  const [clearTrigger, setClearTrigger] = useState(false);
  const [criteriaErrors, setCriteriaErrors] = useState<any[]>([]);

  const { showSnackbar } = useSnackbar();

  const [formData, setFormData] = useState({
    searchQueryID: "",
    generateReport: "",
    reportFormat: "",
    isPublic: false,
  });

  const operator = [
    {
      value: "Equals",
      label: "Exactly Matches =",
    },
    {
      value: "NotEqualString",
      label: "Does Not Contain",
    },
    {
      value: "StartsWith",
      label: "Begins with",
    },
    {
      value: "EndsWith",
      label: "Ends with",
    },
    {
      value: "Contains",
      label: "Contains",
    },
    {
      value: "IN",
      label: "IN",
    },
  ];

  const dateOperator = [
    {
      value: "Equals",
      label: "Exactly Matches =",
    },
    {
      value: "GreaterThan",
      label: "Greater than >",
    },
    {
      value: "GreaterThanOrEqual",
      label: "Greater or equal >=",
    },
    {
      value: "LessThan",
      label: "Less than <",
    },
    {
      value: "LessThanOrEqual",
      label: "Less or equal <=",
    },
    {
      value: "NotEqual",
      label: "Not equal <>",
    },
    {
      value: "Between",
      label: "Between",
    },
  ];

  const saveToHistory = () => {
    setHistory((prev) => [...prev, { left, right, checked }]);
  };

  const undoLastAction = () => {
    if (history.length > 0) {
      const lastState = history[history.length - 1];
      setLeft(lastState.left);
      setRight(lastState.right);
      setChecked(lastState.checked);
      setHistory((prev) => prev.slice(0, -1));
    }
  };

  const handleDragEnd = (result: any) => {
    const { source, destination } = result;
    if (!destination) return;
    if (source.droppableId === destination.droppableId) {
      if (source.droppableId === "available") {
        const newLeft = Array.from(left);
        const [movedItem] = newLeft.splice(source.index, 1);
        newLeft.splice(destination.index, 0, movedItem);
        setLeft(newLeft);
      } else if (source.droppableId === "enabled") {
        const newRight = Array.from(right);
        const [movedItem] = newRight.splice(source.index, 1);
        newRight.splice(destination.index, 0, movedItem);
        setRight(newRight);
      }
      return;
    }
    saveToHistory();
    if (
      source.droppableId === "available" &&
      destination.droppableId === "enabled"
    ) {
      const movedItem = left[source.index];
      const newLeft = [...left];
      newLeft.splice(source.index, 1);
      const newRight = [...right, movedItem];
      setLeft(newLeft);
      setRight(newRight);
    } else if (
      source.droppableId === "enabled" &&
      destination.droppableId === "available"
    ) {
      const movedItem = right[source.index];
      const newRight = [...right];
      newRight.splice(source.index, 1);
      const newLeft = [...left, movedItem];
      setRight(newRight);
      setLeft(newLeft);
    }
    if (
      source.droppableId === "available" &&
      destination.droppableId === "available"
    ) {
      const movedItem = left[source.index];
      const leftItems = [...left];
      leftItems.splice(source.index, 1);
      const newLeft = [...leftItems];
      newLeft.splice(destination.index, 0, movedItem);
      setLeft(newLeft);
    }
    if (
      source.droppableId === "enabled" &&
      destination.droppableId === "enabled"
    ) {
      const movedItem = right[source.index];
      const rightItems = [...right];
      rightItems.splice(source.index, 1);
      const newRight = [...rightItems];
      newRight.splice(destination.index, 0, movedItem);
      setRight(newRight);
    }
  };

  const addCriteria = () => {
    setCriteria([
      ...criteria,
      { id: Date.now(), condition: "", field: "", operator: "", value: "" },
    ]);
  };

  const removeCriteria = (id: any) => {
    setCriteria(criteria.filter((item) => item.id !== id));
  };

  const handleCriteriaChange = (id: any, event: any) => {
    const { name, value } = event.target;
    setCriteria((prevCriteria) =>
      prevCriteria.map((item) =>
        item.id === id ? { ...item, [name]: value } : item
      )
    );
  };

  const validateEmail = (email: any) => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!email.match(emailPattern)) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        emailId: "Please enter a valid email address.",
      }));
    } else {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        emailId: "",
      }));
    }
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTermLeft(event.target.value);
  };

  const handleSearchChangeRight = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSearchTermRight(event.target.value);
  };

  const handleClick = () => {
    setIsOpen((prev) => !prev);
    setFormData((prev) => ({ ...prev, searchQueryID: "" }));
    setClearTrigger(true);
    setIsClearData(true);
    clearData();
  };

  const getFiledsOfReport = async () => {
    const payload = {
      accountId: LocalStorageUtil.getItem("accountId"),
      contextName: LocalStorageUtil.getItem("contextName"),
    };
    setLoading(true);
    try {
      const response = await getFields(payload);
      setLoading(false);
      setLeft(response);
      setData(response);
      const transformedData = transformData(response);
      setFieldsData(transformedData);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getFiledsOfReport();
    saveQuery();
  }, []);

  useEffect(() => {
    if (queryResponse !== undefined) {
      saveQuery();
      getFiledsOfReport();
    }
  }, [queryResponse]);

  const transformData = (data: any[]): Category[] => {
    const categoryMap: { [key: string]: Category } = {};
    data.forEach((item) => {
      const { categoryName, fieldMappingId, field } = item;
      if (!categoryMap[categoryName]) {
        categoryMap[categoryName] = {
          label: categoryName,
          options: [],
        };
      }
      categoryMap[categoryName].options.push({
        value: fieldMappingId,
        label: field,
      });
    });
    return Object.values(categoryMap);
  };

  const handleChange = (event: any) => {
    const { name, value, type, checked } = event.target;
    let finalValue: any;
    if (type === "checkbox") {
      finalValue = checked;
    } else if (type === "number") {
      finalValue = Number(value);
    } else {
      finalValue = value;
    }
    setFormData((prevState) => ({
      ...prevState,
      [name]: finalValue,
    }));
    if (name === "emailId") {
      validateEmail(value);
    }
    if (name === "searchQueryID") {
      handleSaveQueryDetails(finalValue);
    }
  };

  const handleConfirmDialogClose = (confirmed: boolean) => {
    setConfirmDialogOpen(false);
    if (confirmed) {
      getFiledsOfReport();
      setRight([]);
      setCriteria((prevState) =>
        prevState.map((item) => ({
          ...item,
          condition: "",
          field: "",
          operator: "",
          value: "",
        }))
      );
      setFormData({
        generateReport: "",
        searchQueryID: "",
        reportFormat: "",
        isPublic: false,
      });
    }
  };

  const handleSaveQueryDetails = async (finalValue: any) => {
    const payload = {
      SearchQueryID: finalValue,
      Timezone: appSettings.timezone,
      accountId: LocalStorageUtil.getItem("accountId"),
      contextName: LocalStorageUtil.getItem("contextName"),
    };
    try {
      setLoading(true);
      const response = await getsavedQueryDetails(payload);
      setSavedQueryDetails(response);
      setIsClearData(false);
      setLoading(false);
      if (response.schedularData === null) {
        setIsOpen(false);
      } else {
        setIsOpen(true);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!savedQueryDetails?.listSearchCriteriaDetailsModel?.length) return;
    setFormData({
      searchQueryID:
        savedQueryDetails?.listSearchCriteriaDetailsModel[0]?.searchQueryID ||
        "",
      generateReport:
        savedQueryDetails?.listSearchCriteriaDetailsModel[0]?.searchQueryName ||
        "",
      reportFormat:
        savedQueryDetails?.listSearchCriteriaDetailsModel[0]?.reportType || "",
      isPublic:
        savedQueryDetails?.listSearchCriteriaDetailsModel[0]?.isPublic || false,
    });
  }, [savedQueryDetails]);

  useEffect(() => {
    if (savedQueryDetails?.listSearchCriteriaDetailsModel?.length) {
      const mappedCriteria =
        savedQueryDetails.listSearchCriteriaDetailsModel.map((item: any) => ({
          id: item?.searchCriteriaID,
          condition: item?.logicalOperator,
          field: item?.metadataFieldName,
          operator: item?.operator,
          value: item?.value1,
        }));
      setCriteria(mappedCriteria);
    } else {
      setCriteria([
        { id: Date.now(), condition: "", field: "", operator: "", value: "" },
      ]);
    }
    if (savedQueryDetails?.fileInfoReportField) {
      setRight(savedQueryDetails?.fileInfoReportField);
    }
  }, [savedQueryDetails]);

  let getData = (left: any, right: any, criteria: any, reportFormat: any) => {
    setSavedLeftData(left);
    setSavedRightData(right);
    setSavedCriteriaData(criteria);
    setReportFormat(reportFormat);
  };

  const handleDownloadReport = (response: any, format: number) => {
    let fileType = "";
    let fileExtension = "";
    switch (format) {
      case 1:
        fileType = "text/html";
        fileExtension = "html";
        break;
      case 2:
        fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        fileExtension = "xlsx";
        break;
      case 3:
        fileType = "application/pdf";
        fileExtension = "pdf";
        break;
      default:
        console.error("Invalid format");
        return;
    }
    const blob = new Blob([response], { type: fileType });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `report.${fileExtension}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleGenerateReport = async () => {
    const transformedPayload = {
      SearchCriterias: scheduleGenerateReportData?.SearchCriterias || [],
      columnName:
        scheduleGenerateReportData?.savedRightData?.map(
          (item: any) => item.FieldName
        ) || [],
      ColumnFields:
        scheduleGenerateReportData?.savedRightData?.map((item: any) => ({
          columnName: item.FieldName,
          ColumnSort: false,
        })) || [],
      ReportType: scheduleGenerateReportData?.ReportType || "DefaultReport",
      AccountId:
        scheduleGenerateReportData?.AccountID ||
        LocalStorageUtil.getItem("accountId"),
      offSet: appSettings.timezone,
      contextName:
        scheduleGenerateReportData?.contextName ||
        LocalStorageUtil.getItem("contextName"),
      QueueType: 2,
      mappingids:
        scheduleGenerateReportData?.savedRightData?.map(
          (item: any) => item.FieldMappingId
        ) || [],
    };

    const payload = {
      SearchCriterias: generateSearchCriterias(data) || [],
      columnName:
        generateFileInfoReportFields()?.map((item: any) => item.FieldName) ||
        [],
      ColumnFields:
        generateFileInfoReportFields()?.map((item: any) => ({
          columnName: item.FieldName,
          ColumnSort: false,
        })) || [],
      ReportType: Number(formData.reportFormat),
      AccountId: LocalStorageUtil.getItem("accountId"),
      offSet: appSettings.timezone,
      contextName: LocalStorageUtil.getItem("contextName"),
      QueueType: 2,
      mappingids:
        generateFileInfoReportFields()?.map(
          (item: any) => item.FieldMappingId
        ) || [],
    };
    const finalPayload = scheduleGenerateReportData
      ? transformedPayload
      : payload;
    try {
      setLoading(true);
      const response = await generateReport(finalPayload);
      handleUserActivity();
      handleDownloadReport(
        response,
        Number(scheduleGenerateReportData?.ReportType) ||
          Number(formData.reportFormat)
      );
      showSnackbar("File downloaded successfully");
      setLoading(false);
    } catch (error) {
      console.log("error", error);
      showSnackbar("Problem in Donwloading the Report.", true); // red message
    } finally {
      setLoading(false);
    }
  };

  const handleUserActivity = async () => {
    const payload = {
      SearchCriterias:
        savedQueryDetails?.listSearchCriteriaDetailsModel?.map(
          (item: any, index: any) => {
            const matchedField = savedLeftData?.find(
              (leftItem: any) => leftItem.fieldMappingId === item?.fieldId
            );
            return {
              SearchQueryID: item?.searchQueryID,
              SearchCriteriaID: item?.searchCriteriaID,
              MetadataFieldName: savedCriteriaData?.[index]?.field,
              Fielditem: {
                metaDataFieldId: item?.fieldId,
                field: savedCriteriaData?.[index]?.field,
                customField: savedCriteriaData?.[index]?.field,
                categoryName: matchedField?.categoryName || "",
                fieldMappingId: item?.fieldId,
              },
              LogicalOperator: savedCriteriaData?.[index]?.condition || null,
              Operator: savedCriteriaData?.[index]?.operator,
              Value1: savedCriteriaData?.[index]?.value,
              Value2: null,
              Field: item?.fieldId,
              FieldName: savedCriteriaData?.[index]?.field,
            };
          }
        ) || [],

      columnName: savedRightData?.map((item: any) => item.fieldName) || [],

      ColumnFields:
        savedRightData?.map((item: any) => ({
          columnName: item.fieldName,
          ColumnSort: false,
        })) || [],

      ReportType: reportFormat,
      AccountId: LocalStorageUtil.getItem("accountId"),
      offSet: appSettings.timezone,
      contextName: LocalStorageUtil.getItem("contextName"),
      paramGetUrl: "api/advancedSearch/FileInfoReports",
      userId: LocalStorageUtil.getItem("userId"),
      QueueType: 2,
      mappingids: savedRightData?.map((item: any) => item.fieldMappingId) || [],
    };
    try {
      setLoading(true);
      await userActivity(payload);
      setLoading(false);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancelClick = () => {
    setConfirmDialogOpen(true);
  };

  const generateFileInfoReportFields = () => {
    return right.map((field: any, index: any) => ({
      FieldName: field.field || field.fieldName,
      FieldOrder: index,
      Sorting: false,
      FieldMappingId: field.fieldMappingId,
      FileInfoReportID: field?.fileInfoReportID || null,
      SearchQueryID: field?.searchQueryID || null,
    }));
  };

  const generateSearchCriterias = (data: any) => {
    return criteria.map((item: any, index) => {
      const matchedField = data.find((d: any) => d.field === item.field) || {};
      return {
        LogicalOperator: index === 0 ? undefined : item.condition || "AND",
        Fielditem: {
          metaDataFieldId: matchedField.metaDataFieldId ?? null,
          field: item.field,
          customField: item.customField || item.field,
          categoryName: matchedField.categoryName ?? "General Information",
          fieldMappingId: matchedField.fieldMappingId ?? null,
        },
        Operator: item.operator || "Equals",
        Value1: item.value ?? "",
        Value2: null,
        SearchCriteriaID:
          savedQueryDetails?.listSearchCriteriaDetailsModel?.[0]
            ?.searchCriteriaID,
        SearchQueryID:
          savedQueryDetails?.listSearchCriteriaDetailsModel?.[0]?.searchQueryID,
        Field: matchedField.metaDataFieldId ?? null,
        FieldName: item.field,
        MetadataFieldName: item.field ?? null,
      };
    });
  };

  const handleCreate = async () => {
    const errors: any = {};
    let criteriaValidationErrors: any[] = [];    

    if (!formData.generateReport?.trim()) {
      errors.generateReport = "Please select the Report Name";
    }
    if (!formData.reportFormat?.trim()) {
      errors.reportFormat = "Please select the Report Format";
    }
    criteria.forEach((item, index) => {
      const rowErrors: any = {};
      if (!item.field?.trim()) rowErrors.field = "Please select the Field";
      if (!item.operator?.trim())
        rowErrors.operator = "Please select the Operator";
      if (!item.value?.toString().trim())
        rowErrors.value = "Please enter the Value1";

      criteriaValidationErrors[index] = rowErrors;
    });

    if (right.length === 0) {
      setErrors((prev) => ({
        ...prev,
        selectedFieldsError: "Please select the Enabled Fields",
      }));      
    } else {
      setErrors((prev) => ({
        ...prev,
        selectedFieldsError: undefined,
      }));
    }

    const hasFormErrors = Object.keys(errors).length > 0;
    const hasCriteriaErrors = criteriaValidationErrors.some(
      (err) => Object.keys(err).length > 0
    );

    if (hasFormErrors || hasCriteriaErrors) {
      setFormErrors(errors);
      setCriteriaErrors(criteriaValidationErrors);
      return;
    }

    setFormErrors({
      generateReport: "",
      reportFormat: "",
      toEmail: "",
      bccEmail: "",
      ccEmail: "",
    });

    setCriteriaErrors([]);
    const payload = {
      AccountID: LocalStorageUtil.getItem("accountId"),
      CreatedBy: LocalStorageUtil.getItem("userId"),
      IsActive: 1,
      IsPublic: formData.isPublic,
      ModuleType: 2,
      ReportType: formData.reportFormat,
      SearchQueryName: formData.generateReport,
      contextName: LocalStorageUtil.getItem("contextName"),
      FileInfoReportFields: generateFileInfoReportFields(),
      SearchCriterias: generateSearchCriterias(data),
    };
    try {
      setLoading(true);
      const response = await createQuery(payload);
      saveQuery();
      setQueryResponse(response);
      showSnackbar("Query has been saved successfully");
      clearData();
      setLoading(false);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  const updatedFileInfoReportFields = () => {
    return right.map((field: any, index: any) => ({
      SearchQueryID: formData.searchQueryID ?? null,
      FileInfoReportID: field?.fileInfoReportID ?? 0,
      FieldName: field.fieldName || field.field,
      FieldOrder: index + 1,
      Sorting: false,
      FieldMappingId: field.fieldMappingId,
    }));
  };

  const updatedSearchCriterias = (data: any) => {
    return criteria.map((item: any, index) => {
      const matchedField = data.find((d: any) => d.field === item.field) || {};
      return {
        Fielditem: {
          metaDataFieldId: matchedField.metaDataFieldId ?? null,
          field: item.field,
          customField: item.customField || item.field,
          categoryName: matchedField.categoryName ?? "General Information",
          fieldMappingId: matchedField.fieldMappingId ?? null,
        },
        LogicalOperator: item.condition,
        Operator: item.operator || "Equals",
        Value1: item.value ?? "",
        Value2: null,
        Field: matchedField.metaDataFieldId ?? null,
        FieldName: item.field,
      };
    });
  };

  const handleUpdate = async () => {
    const errors: any = {};
    let criteriaValidationErrors: any[] = [];   

    if (!formData?.generateReport) {
      errors.generateReport = "Please select the Report Name";
    }
    if (!formData?.reportFormat) {
      errors.reportFormat = "Please select the Report Format";
    }
    criteria.forEach((item, index) => {
      const rowErrors: any = {};
      if (!item.field?.trim()) rowErrors.field = "Please select the Field";
      if (!item.operator?.trim())
        rowErrors.operator = "Please select the Operator";
      if (!item.value?.toString().trim())
        rowErrors.value = "Please enter the Value1";

      criteriaValidationErrors[index] = rowErrors;
    });
    if (right.length === 0) {
      setErrors((prev) => ({
        ...prev,
        selectedFieldsError: "Please select the Enabled Fields",
      }));     
    } else {
      setErrors((prev) => ({
        ...prev,
        selectedFieldsError: undefined,
      }));
    }
    const hasFormErrors = Object.keys(errors).length > 0;
    const hasCriteriaErrors = criteriaValidationErrors.some(
      (err) => Object.keys(err).length > 0
    );

    if (hasFormErrors || hasCriteriaErrors) {
      setFormErrors(errors);
      setCriteriaErrors(criteriaValidationErrors);
      return;
    }
    setFormErrors({
      generateReport: "",
      reportFormat: "",
      toEmail: "",
      bccEmail: "",
      ccEmail: "",
    });

    setCriteriaErrors([]);
    const payload = {
      searchCriteriaDetailsModel: {
        SearchCriterias: updatedSearchCriterias(data),
        IsPublic: formData.isPublic,
        ModuleType: 2,
        SearchQueryName: formData.generateReport,
        IsActive: false,
        AccountID: Number(LocalStorageUtil.getItem("accountId")),
        CreatedBy: Number(LocalStorageUtil.getItem("userId")),
        ReportType: formData.reportFormat,
        SearchQueryID: formData.searchQueryID ?? null,
        FileInfoReportFields: updatedFileInfoReportFields(),
      },
      contextName: LocalStorageUtil.getItem("contextName"),
    };
    try {
      setLoading(true);
      const response = await updateQueryReport(payload);
      saveQuery();
      setQueryResponse(response);
      showSnackbar("Query has been updated successfully");
      clearData();
      setLoading(false);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  const saveQuery = async () => {
    const payload = {
      AccountID: LocalStorageUtil.getItem("accountId"),
      CreatedBy: LocalStorageUtil.getItem("userId"),
      ModuleType: 2,
      contextName: LocalStorageUtil.getItem("contextName"),
    };
    try {
      setLoading(true);
      const response = await getSaveQuery(payload);
      setSaveQueryData(response);
      setLoading(false);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  const clearData = () => {
    setFormData((prev) => ({
      ...prev,
      searchQueryID: "",
      generateReport: "",
      reportFormat: "",
      isPublic: false,
    }));
    setCriteria([
      { id: Date.now(), condition: "", field: "", operator: "", value: "" },
    ]);
    setRight([]);
  };

  const handleCallback = () => {
    setIsOpen(false);
    setFormData((prev) => ({ ...prev, searchQueryID: "" }));
  };

  const getDataPayload = (data: any) => {
    setScheduleGenerateReportData(data);
  };

  const handleReportCreate = () => {
    setFormData((prev) => ({
      ...prev,
      generateReport: "",
      searchQueryID: "",
      reportFormat: "",
      isPublic: false,
    }));
    setCriteria([
      { id: Date.now(), condition: "", field: "", operator: "", value: "" },
    ]);
    setRight([]);
    setIsClearData(true);
    setClearTrigger((prev) => !prev);
  };

  return (
    <>
      <NavigationBar title="File Info Report" text="File Info Report" />
      <div className="p-4 max-w-4xl mx-auto">
        <Form>
          <Row style={{ display: "flex", justifyContent: "end" }}>
            <Form.Group
              controlId="formCustomer"
              style={{
                width: "auto",
                height: "28px !important",
                marginTop: "7px",
                marginRight: "3px",
              }}
            >
              <Form.Select
                name="searchQueryID"
                onChange={handleChange}
                value={formData.searchQueryID}
                style={{
                  fontSize: "11px",
                  height: "25px",
                }}
              >
                <option value="">Select saved report</option>
                {saveQueryData.map((item: any) => (
                  <option key={item.searchQueryID} value={item.searchQueryID}>
                    {item.searchQueryName}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Button
              variant="contained"
              size="small"
              className="generate-report-btn"
              onClick={handleGenerateReport}
            >
              Generate Report
            </Button>

            {formData.searchQueryID && (
              <Button
                variant="contained"
                size="small"
                onClick={handleReportCreate}
                className="button checkbox-button"
              >
                Create
              </Button>
            )}

            <Button
              variant="contained"
              size="small"
              onClick={handleClick}
              className="button checkbox-button"
            >
              Schedule
              <IconButton
                size="small"
                sx={{ padding: 0, marginLeft: "0.8vh", color: "inherit" }}
              >
                {isOpen ? (
                  <ArrowDropUpIcon fontSize="small" />
                ) : (
                  <ArrowDropDownIcon fontSize="small" />
                )}
              </IconButton>
            </Button>
          </Row>
          {!isOpen ? (
            <div>
              <Row className="mb-3">
                <Col md={3}>
                  <Form.Group controlId="formGroupName">
                    <Form.Label
                      className="input-labels"
                      style={{
                        color: "var(--aggrid-text-color)",
                        fontSize: "11px",
                      }}
                    >
                      Generate Report<span className="required">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      data-testid="generate-report-name"
                      placeholder="Enter the Report Name"
                      name="generateReport"
                      value={formData.generateReport || ""}
                      onChange={handleChange}
                      required
                      isInvalid={!!formErrors.generateReport}
                      disabled={
                        savedQueryDetails?.listSearchCriteriaDetailsModel
                          ?.length
                      }
                      style={{
                        fontSize: "11px",
                      }}
                    />
                    {formErrors.generateReport && (
                      <Form.Control.Feedback type="invalid">
                        {formErrors.generateReport}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group controlId="formCustomer">
                    <Form.Label
                      className="input-labels"
                      style={{
                        color: "var(--aggrid-text-color)",
                        fontSize: "11px",
                      }}
                    >
                      Report Format<span className="required">*</span>
                    </Form.Label>
                    <Form.Select
                      name="reportFormat"
                      value={formData.reportFormat}
                      onChange={handleChange}
                      isInvalid={!!formErrors.reportFormat}
                      style={{
                        fontSize: "11px",
                      }}
                    >
                      <option value="">Select</option>
                      <option value="1">Html</option>
                      <option value="2">Excel</option>
                      <option value="3">Pdf</option>
                    </Form.Select>
                    {formErrors.reportFormat && (
                      <Form.Control.Feedback type="invalid">
                        {formErrors.reportFormat}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group controlId="formApiUser">
                    <Form.Label
                      className="input-labels"
                      style={{
                        color: "var(--aggrid-text-color)",
                        fontSize: "11px",
                      }}
                    >
                      As Public<span className="required">*</span>
                    </Form.Label>
                    <Form.Check
                      type="checkbox"
                      label={
                        <span
                          style={{
                            fontSize: "11px",
                            color: "var(--aggrid-text-color)",
                          }}
                        >
                          Public can be seen by other users
                        </span>
                      }
                      name="isPublic"
                      className="input-labels"
                      style={{ color: "var(--aggrid-text-color)" }}
                      checked={formData.isPublic}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div style={{ paddingTop: "20px", borderRadius: "10px" }}>
                <h6
                  style={{
                    color: "var(--aggrid-text-color)",
                    marginBottom: "1rem",
                    fontSize: "11px",
                  }}
                >
                  Select Report Criteria *
                </h6>
                <Row className="align-items-center mb-2">
                  <Col md={2}>
                    <Form.Label
                      className="input-labels"
                      style={{
                        color: "var(--aggrid-text-color)",
                        fontSize: "11px",
                      }}
                    >
                      AND/OR
                    </Form.Label>
                  </Col>
                  <Col md={3}>
                    <Form.Label
                      className="input-labels"
                      style={{
                        color: "var(--aggrid-text-color)",
                        fontSize: "11px",
                      }}
                    >
                      Field
                    </Form.Label>
                  </Col>
                  <Col md={3}>
                    <Form.Label
                      className="input-labels"
                      style={{
                        color: "var(--aggrid-text-color)",
                        fontSize: "11px",
                      }}
                    >
                      Operator
                    </Form.Label>
                  </Col>
                  <Col md={3}>
                    <Form.Label
                      className="input-labels"
                      style={{
                        color: "var(--aggrid-text-color)",
                        fontSize: "11px",
                      }}
                    >
                      Value1
                    </Form.Label>
                  </Col>
                  <Col md={1}></Col>
                </Row>
                {criteria.map((item, index) => (
                  <Row key={item.id} className="align-items-center mb-2">
                    <Col md={2}>
                      {index !== 0 && (
                        <Form.Select
                          name="condition"
                          value={item.condition}
                          data-testid={"criteria-field-1"}
                          onChange={(e) => handleCriteriaChange(item.id, e)}
                          style={{
                            fontSize: "11px",
                          }}
                        >
                          <option value="">Select</option>
                          <option value="AND">AND</option>
                          <option value="OR">OR</option>
                        </Form.Select>
                      )}
                    </Col>
                    <Col md={3}>
                      <Form.Select
                        name="field"
                        value={item.field}
                        onChange={(e) => handleCriteriaChange(item.id, e)}
                        isInvalid={!!criteriaErrors[index]?.field}
                        style={{
                          fontSize: "11px",
                        }}
                      >
                        <option value="">Select</option>
                        {fieldsData.map((fields) => (
                          <optgroup key={fields.label} label={fields.label}>
                            {fields.options.map((option) => (
                              <option key={option.value} value={option.label}>
                                {option.label}
                              </option>
                            ))}
                          </optgroup>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {criteriaErrors[index]?.field}
                      </Form.Control.Feedback>
                    </Col>
                    <Col md={3}>
                      <Form.Select
                        name="operator"
                        value={item.operator}
                        onChange={(e) => handleCriteriaChange(item.id, e)}
                        isInvalid={!!criteriaErrors[index]?.operator}
                        style={{
                          fontSize: "11px",
                        }}
                      >
                        <option value="">Select</option>
                        {(item.field?.toLowerCase().includes("date")
                          ? dateOperator
                          : operator
                        ).map((op) => (
                          <option key={op.value} value={op.value}>
                            {op.label}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {criteriaErrors[index]?.operator}
                      </Form.Control.Feedback>
                    </Col>
                    <Col md={3}>
                      {item.field?.toLowerCase().includes("date") ? (
                        <>
                          <Form.Control
                            type="date"
                            placeholder="From Date"
                            name="value"
                            max={new Date().toISOString().split("T")[0]}
                            value={item.value || ""}
                            onChange={(e) => handleCriteriaChange(item.id, e)}
                            isInvalid={!!criteriaErrors[index]?.value}
                            style={{
                              padding: ".3em",
                              fontSize: "11px",
                              borderRadius: "4px",
                              border: "1px solid #ccc",
                              marginTop: ".1em",
                              height: "30px",
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            {criteriaErrors[index]?.value}
                          </Form.Control.Feedback>
                        </>
                      ) : (
                        <>
                          <Form.Control
                            type="text"
                            name="value"
                            placeholder="Enter Value"
                            value={item.value}
                            onChange={(e) => handleCriteriaChange(item.id, e)}
                            isInvalid={!!criteriaErrors[index]?.value}
                            style={{
                              fontSize: "11px",
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            {criteriaErrors[index]?.value}
                          </Form.Control.Feedback>
                        </>
                      )}
                    </Col>
                    <Col md={1} className="d-flex gap-2">
                      {criteria.length > 1 && (
                        <IconButton
                          size="medium"
                          sx={{
                            padding: 0,
                            marginLeft: "8px",
                            color: "inherit",
                          }}
                          onClick={() => removeCriteria(item.id)}
                        >
                          <DeleteOutlineIcon
                            fontSize="medium"
                            sx={{ color: "var(--text-color)" }}
                          />
                        </IconButton>
                      )}
                      <IconButton
                        size="medium"
                        sx={{ padding: 0, marginLeft: "8px", color: "inherit" }}
                        onClick={addCriteria}
                      >
                        <AddIcon
                          fontSize="medium"
                          sx={{ color: "var(--text-color)" }}
                        />
                      </IconButton>
                    </Col>
                  </Row>
                ))}
              </div>
              <Row>
                <h6
                  style={{
                    color: "var(--aggrid-text-color)",
                    marginBottom: "1rem",
                    fontSize: "11px",
                  }}
                >
                  Select Fields and Order
                </h6>
                <DragDropContext onDragEnd={handleDragEnd}>
                  <Row style={{ margin: "10px" }}>
                    <Col md={4}>
                      <Form.Label
                        className="input-labels"
                        style={{
                          color: "var(--aggrid-text-color)",
                          fontSize: "11px",
                        }}
                      >
                        Available<span className="required">*</span>
                      </Form.Label>
                      <TextField
                        fullWidth
                        placeholder="Search"
                        value={searchTermLeft}
                        onChange={handleSearchChange}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          bgcolor: "white",
                          marginBottom: "10px",
                          borderRadius: "8px",
                          "& .MuiOutlinedInput-root": {
                            height: "35px",
                            borderRadius: "8px",
                            "& fieldset": {
                              borderColor: "#ccc",
                            },
                            "&:hover fieldset": {
                              borderColor: "#888",
                            },
                            "& input": {
                              fontSize: "11px",
                            },
                          },
                        }}
                        variant="outlined"
                      />
                      <Droppable droppableId="available">
                        {(provided) => (
                          <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            style={{
                              width: "100%",
                              height: "490px",
                              overflow: "auto",
                              backgroundColor: "#f8f9fa",
                              border: "1px solid #ccc",
                              borderRadius: "8px",
                              fontSize: "11px",
                            }}
                          >
                            {left
                              .filter(
                                (item: any) =>
                                  searchTermLeft === "" ||
                                  item?.field
                                    ?.toLowerCase()
                                    .includes(searchTermLeft.toLowerCase()) ||
                                  item?.fieldName
                                    ?.toLowerCase()
                                    .includes(searchTermLeft.toLowerCase())
                              )
                              .map((item: any, index: number) => (
                                <Draggable
                                  key={
                                    item.mappingAutoId ||
                                    item.metaDataFieldId ||
                                    item.fileInfoReportID
                                  }
                                  draggableId={`${
                                    item.mappingAutoId ||
                                    item.metaDataFieldId ||
                                    item.fileInfoReportID
                                  }`}
                                  index={index}
                                >
                                  {(provided) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      style={{
                                        ...provided.draggableProps.style,
                                        padding: "8px",
                                        margin: "4px",
                                        backgroundColor: "white",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        cursor: "grab",
                                        color: "black",
                                      }}
                                    >
                                      {`${String(index + 1).padStart(
                                        2,
                                        "0"
                                      )}. ${
                                        item.category
                                          ? `${item.category} - `
                                          : ""
                                      }${item.field || item.fieldName}`}
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </Col>
                    <Col
                      md={1}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        sx={{ my: 0.5 }}
                        variant="outlined"
                        size="small"
                        onClick={undoLastAction}
                        disabled={history.length === 0}
                        aria-label="undo last action"
                        style={{
                          color: "var(--aggrid-text-color)",
                          border: "1px solid var(--aggrid-text-color)",
                        }}
                      >
                        <RefreshIcon
                          fontSize="small"
                          sx={{
                            fontSize: "14px",
                            height: "14px",
                            width: "14px",
                          }}
                        />
                      </Button>
                    </Col>

                    {/* Right (Enabled) */}
                    <Col md={4}>
                      <Form.Label
                        className="input-labels"
                        style={{
                          color: "var(--aggrid-text-color)",
                          fontSize: "11px",
                        }}
                      >
                        Enabled<span className="required">*</span>
                      </Form.Label>
                      <TextField
                        fullWidth
                        placeholder="Search"
                        value={searchTermRight}
                        onChange={handleSearchChangeRight}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          bgcolor: "white",
                          borderRadius: "8px",
                          marginBottom: "10px",
                          "& .MuiOutlinedInput-root": {
                            height: "35px",
                            borderRadius: "8px",
                            "& fieldset": {
                              borderColor: "#ccc",
                            },
                            "&:hover fieldset": {
                              borderColor: "#888",
                            },
                            "& input": {
                              fontSize: "11px",
                            },
                          },
                        }}
                        variant="outlined"
                      />
                      <Droppable droppableId="enabled">
                        {(provided) => (
                          <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            style={{
                              width: "100%",
                              height: "490px",
                              overflow: "auto",
                              backgroundColor: "#f8f9fa",
                              border: "1px solid #ccc",
                              borderRadius: "8px",
                              fontSize: "11px",
                            }}
                          >
                            {right
                              .filter(
                                (item: any) =>
                                  searchTermRight === "" ||
                                  item?.field
                                    ?.toLowerCase()
                                    .includes(searchTermRight.toLowerCase()) ||
                                  item?.fieldName
                                    ?.toLowerCase()
                                    .includes(searchTermRight.toLowerCase())
                              )
                              .map((item: any, index: number) => (
                                <Draggable
                                  key={
                                    item.mappingAutoId ||
                                    item.metaDataFieldId ||
                                    item.fileInfoReportID
                                  }
                                  draggableId={`${
                                    item.mappingAutoId ||
                                    item.metaDataFieldId ||
                                    item.fileInfoReportID
                                  }`}
                                  index={index}
                                >
                                  {(provided) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      style={{
                                        ...provided.draggableProps.style,
                                        padding: "8px",
                                        margin: "4px",
                                        backgroundColor: "white",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        cursor: "grab",
                                        color: "black",
                                      }}
                                    >
                                      {`${String(index + 1).padStart(
                                        2,
                                        "0"
                                      )}. ${
                                        item.category
                                          ? `${item.category} - `
                                          : ""
                                      }${item.field || item.fieldName}`}
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                      {errors.selectedFieldsError && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "0.85rem",
                            marginTop: "4px",
                          }}
                        >
                          {errors.selectedFieldsError}
                        </div>
                      )}
                    </Col>
                  </Row>
                </DragDropContext>
              </Row>
              <Row
                style={{
                  display: "flex",
                  justifyContent: "end",
                  margin: "10px",
                }}
              >
                {savedQueryDetails?.listSearchCriteriaDetailsModel?.length &&
                isClearData !== true ? (
                  <Button
                    variant="contained"
                    className="update-button"
                    onClick={handleUpdate}
                  >
                    Update
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    className="update-button"
                    onClick={handleCreate}
                  >
                    Create
                  </Button>
                )}
                <Button
                  variant="contained"
                  className="cancel-button"
                  onClick={handleCancelClick}
                >
                  Cancel
                </Button>
              </Row>

              <ConfirmDialog
                open={confirmDialogOpen}
                onClose={handleConfirmDialogClose}
                title="File Info Report"
                content="Are you sure you want to Cancel?"
              />
            </div>
          ) : (
              <Collapse in={isOpen}>
                <div>
                  <Grid
                    container
                    spacing={2}
                    sx={{
                      marginTop: "2vh",
                      display: "flex",
                      justifyContent: "end",
                    }}
                    alignItems="center"
                  ></Grid>
                  {isOpen && (
                      <ScheduleFileInfoReport
                        fieldsData={fieldsData}
                        leftData={data}
                        isOpen={isOpen}
                        savedQueryDetails={savedQueryDetails}
                        getData={getData}
                        getDataPayload={getDataPayload}
                        handleCallback={handleCallback}
                        clearTrigger={clearTrigger}
                        setSavedQueryDetails={setSavedQueryDetails}
                        saveQuery={saveQuery}
                      />
                  )}
                </div>
              </Collapse>
          )}
        </Form>
      </div>
    </>
  );
};

export default FileInfoReport;
